import Auth from '@client/controllers/Auth';
import Dashboard from '@client/controllers/Dashboard';
import UserRoles from '@client/controllers/UserRoles';
import Users from '@client/controllers/Users';
import Departments from '@client/controllers/Departments';
import Clients from '@client/controllers/Clients';
import OrderStatuses from '@client/controllers/OrderStatuses';
import Orders from '@client/controllers/Orders';
import Units from '@client/controllers/Units';
import Products from '@client/controllers/Products';
import PaymentTypes from '@client/controllers/PaymentTypes';
import OrderProductStatuses from '@client/controllers/OrderProductStatuses';
import Profile from '@client/controllers/Profile';
import OrdersCalendar from '@client/controllers/OrdersCalendar';
import OrderTags from '@client/controllers/OrderTags';
import Operations from '@client/controllers/Operations';
import Contractors from '@client/controllers/Contractors';
import ContractorCategories from '@client/controllers/ContractorCategories';
import Variables from '@client/controllers/Variables';
import Materials from '@client/controllers/Materials';
import TechOperations from '@client/controllers/TechOperations';
import MaterialCategories from '@client/controllers/MaterialCategories';
import Checklists from '@client/controllers/Checklists';
import Purchases from '@client/controllers/Purchases';
import ExternalApplications from '@client/controllers/ExternalApplications';
import Chat from '@client/controllers/Chat';
import Knowledge from '@client/controllers/Knowledge';
import Import from '@client/controllers/Import';

export default {
    'Auth': Auth,
    'Import': Import,
    'Dashboard': Dashboard,
    'Users': Users,
    'Profile': Profile,
    'UserRoles': UserRoles,
    'Departments': Departments,
    'Clients': Clients,
    'OrderStatuses': OrderStatuses,
    'Orders': Orders,
    'Units': Units,
    'Products': Products,
    'PaymentTypes': PaymentTypes,
    'OrderProductStatuses': OrderProductStatuses,
    'OrderTags': OrderTags,
    'OrdersCalendar': OrdersCalendar,
    'Operations': Operations,
    'Contractors': Contractors,
    'ContractorCategories': ContractorCategories,
    'Variables': Variables,
    'Materials': Materials,
    'TechOperations': TechOperations,
    'MaterialCategories': MaterialCategories,
    'Checklists': Checklists,
    'Purchases': Purchases,
    'ExternalApplications': ExternalApplications,
    'Chat': Chat,
    'Knowledge': Knowledge,
};
